module.exports = __webpack_public_path__ + "static/media/done.1a985680.svg";